<ng-container *ngIf="predicates?.length > 0">
  <ng-container *ngIf="operators.length > 0; else singlePredicate">
    <ng-container
      *ngFor="
        let predicateOperator of operators;
        let first = first;
        trackBy: trackById
      "
      data-dgat="predicate-list-eca"
    >
      <ng-container *ngIf="first">
        {{ predicateOperator.firstPredicate.fieldName }}
        {{ predicateOperator.firstPredicate.comparisonOperator }}
        {{ predicateOperator.firstPredicate.comparisonValue }}
        {{ predicateOperator.operator }}
        {{ predicateOperator.secondPredicate.fieldName }}
        {{ predicateOperator.secondPredicate.comparisonOperator }}
        {{ predicateOperator.secondPredicate.comparisonValue }}
      </ng-container>
      <ng-container *ngIf="!first">
        {{ predicateOperator.operator }}
        {{ predicateOperator.secondPredicate.fieldName }}
        {{ predicateOperator.secondPredicate.comparisonOperator }}
        {{ predicateOperator.secondPredicate.comparisonValue }}
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #singlePredicate>
  {{ predicates[0].fieldName }}
  {{ predicates[0].comparisonOperator }}
  {{ predicates[0].comparisonValue }}
</ng-template>
